import {
  signInWithPopup,
  GoogleAuthProvider,
  browserPopupRedirectResolver,
} from "firebase/auth";
import { auth } from "config/firebase";
import { FirebaseError } from "firebase/app";
import { MultiFactorError } from "@firebase/auth";
import { apiClient } from "@/api";

export const handleLoginWithGoogle = async (): Promise<
  MultiFactorError | FirebaseError | void
> => {
  const provider = new GoogleAuthProvider();
  try {
    await signInWithPopup(auth, provider, browserPopupRedirectResolver);
  } catch (error: any) {
    if (
      error?.code === "auth/multi-factor-auth-required" ||
      error?.code === "auth/popup-closed-by-user" ||
      error?.code === "auth/cancelled-popup-request" ||
      error?.code === "auth/user-disabled" ||
      error?.code === "auth/account-exists-with-different-credential" ||
      error?.code === "auth/browser-not-supported" ||
      (error?.message &&
        (error.message.includes("ReCAPTCHA") ||
          error.message.includes("AppCheck")))
    ) {
      throw error;
    }

    if (
      error?.code !== "auth/internal-error" &&
      !error?.message?.toLowerCase().includes("network") &&
      !error?.message?.toLowerCase().includes("deadline exceeded")
    ) {
      throw error;
    }
  } finally {
    apiClient.shared.trackLogin();
  }
};
